import { Avatar as AvatarBase } from './Avatar';
import { AvatarLabelGroup } from './AvatarLabelGroup';

export const Avatar = Object.assign(AvatarBase, {
    LabelGroup: AvatarLabelGroup,
});

export type { AvatarProps } from './Avatar';
export type { AvatarLabelGroupProps } from './AvatarLabelGroup';
